import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

const CustomNavTabs = ({ activeTab, onTabChange,navItems }) => {

    return (
        <>
            <Nav tabs className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3">
                {navItems.map((item) => (
                    <NavItem key={item.id}>
                        <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({ active: activeTab === item.id })}
                            onClick={() => onTabChange(item.id)}
                        >
                            {item.label}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>
        </>
    );
};

export { CustomNavTabs }